$(function() {

    if ($('#tribe-events').length ) {
            $('#tribe-bar-dates .label-tribe-bar-date').text('Date');
            $('.tribe-bar-search-filter .label-tribe-bar-search').text('Event');
            $('.tribe-bar-geoloc-filter .label-tribe-bar-geoloc').text('Your Location');
    }
});



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/events.js